/*
  @route    GET https://REACT_APP_API_URL/team
  @desc     Get all team members
  @access   Public
*/
export async function getTeam() {
  try {
    const url = `https://p01--afix-payload-mk2--w7xsf9cwbfgg.code.run/api/team`;
    const response = await fetch(url, {
      method: "GET",
      // mode: "no-cors",
    });
    // console.log(response);
    const result = await response.json();
    // console.log(result);
    return { response, result };
  } catch (error) {
    console.log(error);
    return null;
  }
}
